/**
 * Maps a notification (type + linkId) to the in-app route to open. Shared by the
 * in-app dropdown tap handler and the push-notification tap handler so both land
 * in the same place.
 */
import { EXPAND_CHALLENGE_PARAM } from '../../challenges/constants/challenges.constants'
import { ARENA_PATH } from '../constants/notifications.constants'
import type { NotificationType } from '../types/notifications.types'

/** Notification types that deep-link into a challenge on the Arena page. */
export const CHALLENGE_NOTIFICATION_TYPES: ReadonlySet<NotificationType> = new Set([
  'CHALLENGE_INVITE',
  'CHALLENGE_ACCEPTED',
  'CHALLENGE_DECLINED',
  'CHALLENGE_CANCELED',
  'CHALLENGE_STARTED',
  'CHALLENGE_REMIND',
  'CHALLENGE_COMPLETED',
])

/**
 * Returns the route to navigate to for a notification, or null when the type has
 * no destination.
 */
export function buildNotificationRoute(
  type: NotificationType | undefined,
  linkId: string | null | undefined,
): string | null {
  if (!type || !CHALLENGE_NOTIFICATION_TYPES.has(type)) return null
  if (linkId) {
    return `${ARENA_PATH}?${EXPAND_CHALLENGE_PARAM}=${encodeURIComponent(linkId)}`
  }
  return ARENA_PATH
}
